import { Box, BoxProps, SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';

interface IconWrapperProps extends BoxProps {
  readonly size?: keyof typeof sizeMap | number;
  readonly children: ReactNode;
}

const sizeMap = {
  xxs: '8px',
  xs: '14px',
  s: '16px',
  m: '24px',
  l: '32px',
  xl: '40px',
};

export const IconWrapper = ({ size = 'm', children, ...boxProps }: IconWrapperProps) => {
  const iconSize = typeof size === 'number' ? size : sizeMap[size];
  const { color, sx, ...restBoxProps } = boxProps;

  return (
    <Box
      {...restBoxProps}
      sx={
        [
          {
            width: iconSize,
            height: iconSize,
            display: 'grid',
            placeItems: 'center',
            color,
            svg: { width: '100%', height: '100%' },
            flex: 'none',
          },
          sx ?? false,
        ].flat() as SxProps<Theme>
      }
    >
      {children}
    </Box>
  );
};
